import { RISK_STATUS } from './cache-constants';
import { SEMAPHORE_COLORS, SEMAPHORE_TEXT_ES } from './semaphore-base';

export const RISK_STATUS_COLORS = {
  [RISK_STATUS.GREEN]: SEMAPHORE_COLORS.green,
  [RISK_STATUS.YELLOW]: SEMAPHORE_COLORS.yellow,
  [RISK_STATUS.RED]: SEMAPHORE_COLORS.red,
  [RISK_STATUS.PENDING]: SEMAPHORE_COLORS.pending,
};

export const RISK_STATUS_TEXT = {
  [RISK_STATUS.GREEN]: SEMAPHORE_TEXT_ES.green,
  [RISK_STATUS.YELLOW]: SEMAPHORE_TEXT_ES.yellow,
  [RISK_STATUS.RED]: SEMAPHORE_TEXT_ES.red,
  [RISK_STATUS.PENDING]: SEMAPHORE_TEXT_ES.pending,
};
